import frustumCull from '../frustumCull'

export default `
  uniform sampler2D uTexture;
  uniform vec4 uRectData;

  varying vec2 vUv;
  
  void main() {
    vec4 color = texture2D(uTexture, vUv);
    ${frustumCull}
    gl_FragColor = color;
  }

`
